import { RichSunOutlined, CurvedMoonOutlined } from './SVG'

export default (config = {}) => {
	return `<div class="_track wp-dark-mode-ignore"><div class="_thumb wp-dark-mode-ignore"><div class="_icon wp-dark-mode-ignore">${config.iconLight || RichSunOutlined}</div><div class="_icon wp-dark-mode-ignore">${config.iconDark || CurvedMoonOutlined}</div></div></div>`
}